import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import logBehaviorMixin from 'next/javascripts/mixins/log-behavior-mixin';
import 'next/stylesheets/components/upgrade-plan-feature/index';

Component('tr-upgrade-plan-feature', {
  properties: {
    name: String,
    logUrl: String,
  },

  mixins: [eventListenerMixin, logBehaviorMixin],

  connected() {
    this.introVideo = this.querySelector('video.intro-video');
    if (this.hasAttribute('before-cache')) this.setAttribute('is-cache', true);
    this.listenTo(this.querySelector('.upgrade-button'), 'click', () => {
      this.sendLogBehavior(this.callToActionLogParams('click_upgrade'));
    });
  },

  ready() {
    if (this.introVideo && !this.isCache()) {
      this.listenTo(this.introVideo, 'play', this.onVideoPlay.bind(this), { once: true });
      this.listenTo(this.introVideo, 'ended', this.onVideoPlay.bind(this), { once: true });
      this.sendLogBehavior(this.videoLogParams('show'));
    }
    if (!this.isCache()) {
      this.sendLogBehavior(this.callToActionLogParams('show'));
    }
  },

  disconnected() {
    this.stopListening();
    if (!this.isCache()) this.logVideoPlayCurrentTime();
  },

  beforeCache() {
    this.setAttribute('before-cache', true);
  },

  onVideoPlay() {
    this.sendLogBehavior('videoplay');
  },

  onVideoEnded() {
    this.sendLogBehavior('videoended');
  },

  logVideoPlayCurrentTime() {
    if (!this.introVideo) return;

    this.sendLogBehavior({ ...this.videoLogParams('close'), extraValues: { currentTime: this.introVideo.currentTime } });
  },

  videoLogParams(action) {
    return {
      resourceType: 'UpgradePlanFeature',
      behaviorAction: `tr-upgrade-plan-feature:${action}`,
    };
  },

  callToActionLogParams(action) {
    return {
      resourceType: 'CallToAction',
      behaviorAction: action,
      extraValues: {
        name: this.name,
      },
    };
  },

  isCache() {
    return this.hasAttribute('is-cache');
  },
});
